function n(n){return n}export{n as renderIcon};
//# sourceMappingURL=icon.renderer.js.map
